const notes = [
   {
      key: 1,
      title: "Education",
      content: (
         <div className="school-college2">
            <h4>Shree Ganesh High School</h4>
            <p className="flex-space-between2">Bihar board<span>Bakhtiyarpur, Patna</span></p>
            <p className="flex-space-between2">10th Science 1st DIV (69.4%)<span>2018-2019</span></p>
            <h4>RLSY College </h4>
            <p className="flex-space-between2">Bihar board<span>Bakhtiyarpur, Patna</span></p>
            <p className="flex-space-between2">11th & 12th to PCM 1st DIV (61.4%) <span>2019-2021</span></p>
            <h4>Disha College </h4>
            <p className="flex-space-between2">Pt. Ravishankar University <span>Raipur, Chattisgarh</span></p>
            <p className="flex-space-between2">Bachelor of computer application (76.57%)  <span>2021-2024</span></p>
            <h4>Raipur Institute of Technology</h4>
            <p className="flex-space-between2">CG Swami Vivekanand Technical University<span>Raipur, Chattisgarh</span></p>
            <p className="flex-space-between2">Master of computer application<span>2024-2026</span></p>
         </div>
      )
   },

   {
      key: 2,
      title: "Skills",
      content: (
         <div className="school-college">
            <p className="flex-space-between">Languages&nbsp;: &nbsp; &nbsp; &nbsp; &nbsp; <span> C, C++, Java, Kotlin, Dart, Python, Visual Basic, HTML, CSS, Javascripts, ES6+, SQL, Git</span></p>
            <p className="flex-space-between">Libraries&nbsp;: <span> ReactJs, JQuery, Axios, antd, MUI</span></p>
            <p className="flex-space-between">Frameworks&nbsp;: <span>React Native,Flutter, VB.net, Express.js, Django</span></p>
            <p className="flex-space-between">APIs&nbsp;: <span> REST APIs (get, post, put, patch, delete)</span></p>
            <p className="flex-space-between">
               Platforms&nbsp;:
               <span>VS Code, Android Studio, Windows, macOS, Linux, Postman</span>
            </p>

            <p className="flex-space-between">
               Deployment & DevOps&nbsp;:
               <span>VPS, Linux, NGINX, PM2, SSL/HTTPS, Netlify, Vercel, Render</span>
            </p>

            <p className="flex-space-between">
               Version Control&nbsp;:
               <span>Git, GitHub</span>
            </p>
         </div>
      )
   },


   {
      key: 3,
      title: "Experience",
      content: (
         <div className="experience">
            {/* <p>Worked With National Internet Exchange of India(NIXI)</p> */}
            {/* <br /> */}
            <h4>Full Stack Developer Intern</h4>
            <p>Yashvitech IT Solotion (Raipur) - 15/04/2025 - 31/01/2026  <a style={{ color: "white" }} href="https://www.yashvitech.com/" target="__blank">Yashvitech</a></p>
            <br />
            <h4>Backend Developer</h4>
            <p>SP Advertising <a style={{ color: "white" }} href="https://spadvertising.in/" target="__blank">SP Advertising</a></p>

         </div>
      )
   },

   {
      key: 4,
      title: "MERN Dev",
      content: (
         <div>
            <div className="category">
               <h4>Frontend</h4>
               <h4>Backend</h4>
               <h4>Database&nbsp; &nbsp;  &nbsp;</h4>
            </div>
            <div className="category">
               <ul>
                  <li>HTML</li>
                  <li>CSS</li>
                  <li>Javascripts</li>
                  <li>React</li>
                  <li>Bootstrap</li>
               </ul>
               <ul>
                  <li>NodeJs</li>
                  <li>ExpressJS</li>
               </ul>
               <ul>
                  <li>MySQL</li>
                  <li>MongoDB</li>
                  <li>PostgresSQL</li>
               </ul>
            </div>
         </div>
      )
   },
   {
      key: 5,
      title: "Full Stack Developer",
      content: (
         <div>
            <div className="category">
               <h4>Frontend</h4>
               <h4>Backend</h4>
               <h4>Database&nbsp; &nbsp;  &nbsp;</h4>
            </div>
            <div className="category">
               <ul>
                  <li>HTML</li>
                  <li>CSS</li>
                  <li>Javascripts</li>
                  <li>React</li>
                  <li>Bootstrap</li>
                  <li>Tailwindcss</li>
               </ul>
               <ul>
                  <li>Python &nbsp; &nbsp; </li>
                  <li>Django</li>
               </ul>
               <ul>
                  <li>MySQL &nbsp; &nbsp;</li>
                  <li>MongoDB &nbsp; &nbsp;</li>
               </ul>
            </div>
         </div>
      )
   },

   {
      key: 6,
      title: "App Developer",
      content: (
         <div>
            <div className="category">
               <h4>Development</h4>
               <h4>State Management</h4>
               <h4>Backend & Services &nbsp;&nbsp;&nbsp;</h4>
            </div>

            <div className="category">
               <ul>
                  <li>Flutter</li>
                  <li>Dart</li>
                  <li>React Native</li>
                  <li>Responsive UI</li>
               </ul>

               <ul>
                  <li>Provider</li>
               </ul>

               <ul>
                  <li>Firebase</li>
                  <li>Firebase Authentication</li>
                  <li>Cloud Firestore</li>
               </ul>
            </div>
         </div>
      )
   },

   {
      key: 7,
      title: "Projects",
      content: (
         <div className="school-college">

            <h4>WhatsApp Chatbot System</h4>
            <p>Tech Used : React.js, Node.js, Express.js, MongoDB, WhatsApp Cloud API</p>
            <p>Role : MERN</p>
            <p>
               <a href="https://spadvertising.tech/" target="_blank" rel="noopener noreferrer">
                  View Project
               </a>
            </p>
            <hr />

            <h4>SP Advertising CRM </h4>
            <p>Tech Used : React.js, Node.js, Express.js, MySQL, Facebook Graph API</p>
            <p>Role : Full-Stack Developer</p>
            <p>
               <a href="https://crm.spadvertising.in/" target="_blank" rel="noopener noreferrer">
                  View Project
               </a>
            </p>
            <hr />

            <h4>Mahesh Ventures Custom CRM</h4>
            <p>Tech Used : React.js, Node.js, Express.js, MySQL</p>
            <p>Role : Full-Stack Developer</p>
            <p>
               <a href="https://crm.maheshventures.in/#/" target="_blank" rel="noopener noreferrer">
                  View Project
               </a>
            </p>
            <hr />

            <h4>KP & GRANDSONS – ERP</h4>
            <p>Tech Used : React.js, Python, Django, MUI, PostgreSQL</p>
            <p>Role : Full-Stack Developer</p>
            <p>
               <a href="https://erp.kpgrandsons.in/" target="_blank" rel="noopener noreferrer">
                  View Project
               </a>
            </p>
            <hr />

            <h4>KeepNote – Cross-Platform Notes App</h4>
            <p>Tech Used : Flutter, Dart, Firebase, Provider</p>
            <p>Role : App Developer</p>
            <p>
               <a href="YOUR_LINK" target="_blank" rel="noopener noreferrer">
                  View Project
               </a>
            </p>
            <hr />

            <h4>Billing System</h4>
            <p>Tech Used : React.js, IndexedDB, JavaScript, HTML, CSS</p>
            <p>Role : Frontend Developer</p>
            <p>
               <a href="https://asarpex-billing-system.netlify.app/" target="_blank" rel="noopener noreferrer">
                  View Project
               </a>
            </p>

            <h4>Social Media Web App</h4>
            <p>Tech Used : MongoDB, Express.js, React.js, Node.js, Socket.IO, WebSocket, Axios, Ant Design</p>
            <p>Role : Full-Stack Developer</p>
            <p>
               <a href="YOUR_LINK" target="_blank" rel="noopener noreferrer">
                  View Project
               </a>
            </p>
            <hr />

            <h4>Grocery Management System</h4>
            <p>Tech Used : React.js, Python, Django, MySQL</p>
            <p>Role : Full-Stack Developer</p>
            <p>
               <a href="https://grocery-shop-management-system-fe.onrender.com/" target="_blank" rel="noopener noreferrer">
                  View Project
               </a>
            </p>

         </div>
      )
   },
   // {
   //    key: 7,
   //    title: " Courses Subjects ", // Update the title to avoid duplication
   //    content: (
   //       <div className="school-college">
   //          {/* <h4>Subjects</h4> */}
   //          <p>Operating system</p>
   //          <p>Computer Networks</p>
   //          <p>Web technology (HTML, CSS, Javascripts)</p>
   //          <p>Computer system architecture</p>
   //          <p>Object Oriented Programming (C++, JAVA, Visual Basic, Python)</p>
   //          <p>Database Management System(& ADBMS)</p>
   //          <p>PC Software & Multimedia (MS word, Excel, Powerpoint, Access, Animation & Graphics)</p>
   //          <p>Artificial Intelligence</p>
   //          <p>Digital Marketing </p>
   //          <p>Data Structures and Algorithms</p>
   //          <p>Software Engineering and Project Management </p>
   //       </div>

   //    )
   // },
   // {
   //    key: 8,
   //    title: "Certificates", // Update the title to avoid duplication
   //    content: (
   //       <div className="school-college">
   //          {/* <h4>Online Course</h4> */}
   //          <p>Full Stack Web Developer by Udemy </p>
   //          <p>Workshop On Computer Networks</p>
   //          <p>Communication Skills</p>
   //       </div>
   //    )
   // },

   {
      key: 9,
      title: "Languages", // Update the title to avoid duplication
      content: (
         <div className="school-college">
            <p>English</p>
            <p>Hindi</p>
         </div>
      )
   }

]

export default notes;